export function isValidMilestoneRoles(roles) {
  if (!roles?.length) return true;

  if (roles.some(({ region, functionalArea }) => !region || !functionalArea)) {
    return false;
  }

  let roleKeys = [];

  const filteredRoles = roles.filter(
    ({ defaultForProductCategories }) => defaultForProductCategories?.length
  );

  for (const {
    defaultForProductCategories,
    roleId,
    region,
    functionalArea,
  } of filteredRoles) {
    roleKeys = roleKeys.concat(
      defaultForProductCategories.map(
        (category) => `${roleId}-${region}-${functionalArea}-${category}`
      )
    );
  }

  const rolesWithoutProductCategoriesKeys = roles
    .filter(
      ({ defaultForProductCategories }) =>
        !defaultForProductCategories || defaultForProductCategories.length === 0
    )
    .map(
      ({ roleId, region, functionalArea }) =>
        `${roleId}-${region}-${functionalArea}`
    );

  if (
    rolesWithoutProductCategoriesKeys.length !==
    new Set(rolesWithoutProductCategoriesKeys).size
  ) {
    return false;
  }

  if (
    rolesWithoutProductCategoriesKeys.some((roleWithoutProdCatKey) =>
      roleKeys.find((key) => key.includes(roleWithoutProdCatKey))
    )
  ) {
    return false;
  }

  return roleKeys.length === new Set(roleKeys).size;
}

export function hasDuplicateMilestoneGroups(groups) {
  if (!groups?.length) return false;

  let groupProductCategoryPairs = [];

  const filteredGroups = groups.filter(
    (group) => group.defaultForProductCategories?.length
  );

  for (const { defaultForProductCategories, groupId } of filteredGroups) {
    if (defaultForProductCategories?.length) {
      groupProductCategoryPairs = groupProductCategoryPairs.concat(
        defaultForProductCategories.map((category) => `${groupId}-${category}`)
      );
    } else {
      groupProductCategoryPairs.push(groupId);
    }
  }

  const allProductCategoryGroups = groups.filter(
    ({ defaultForProductCategories }) => !defaultForProductCategories?.length
  );

  if (
    allProductCategoryGroups.some(({ groupId }) =>
      groupProductCategoryPairs.some((pair) => pair.includes(groupId))
    )
  ) {
    return true;
  }

  return (
    groupProductCategoryPairs.length !== new Set(groupProductCategoryPairs).size
  );
}

export function hasDuplicateCoreTeamGroups(groups) {
  if (!groups?.length) return false;

  if (
    groups.some(
      ({ defaultForProductCategories }) => !defaultForProductCategories?.length
    ) &&
    groups.length > 1
  ) {
    return true;
  }

  const productCategories = groups
    .map((group) => group.DefaultForProductCategories || ["empty"])
    .flat();

  return productCategories.length !== new Set(productCategories).size;
}

export const forceUpdateMilestonesOnTargetDatesChange = (
  milestoneId,
  projectTemplateToUpdate
) => {
  const targetDatesMilestone = projectTemplateToUpdate?.milestones?.find(
    ({ id, targetDatesRequired }) =>
      id === milestoneId && targetDatesRequired === true
  );

  const projectTemplateUpdate = { ...projectTemplateToUpdate };

  if (!targetDatesMilestone) return projectTemplateUpdate;

  const filteredMilestones = projectTemplateUpdate.milestones.filter(
    ({ targetDatesRequired, id, defaultFor }) =>
      targetDatesRequired === true && id !== milestoneId && defaultFor?.length
  );

  for (const milestoneToUpdate of filteredMilestones) {
    milestoneToUpdate.defaultFor = milestoneToUpdate.defaultFor.filter(
      (defaultCategory) =>
        !targetDatesMilestone.defaultFor.includes(defaultCategory)
    );
    if (milestoneToUpdate.defaultFor.length === 0) {
      milestoneToUpdate.targetDatesRequired = false;
    }
  }

  return projectTemplateUpdate;
};

export const forceUpdateMilestonesOnPrepopulationChange = (
  milestoneId,
  projectTemplateToUpdate
) => {
  const targetDatesMilestone = projectTemplateToUpdate?.milestones?.find(
    ({ id, targetDatePrepopulationSource }) =>
      id === milestoneId && targetDatePrepopulationSource !== null
  );

  const projectTemplateUpdate = { ...projectTemplateToUpdate };

  if (!targetDatesMilestone) return projectTemplateUpdate;

  const projectMilestonesToUpdate = projectTemplateUpdate?.milestones?.filter(
    ({ id, defaultFor, targetDatePrepopulationSource }) =>
      targetDatesMilestone?.defaultFor?.some(
        (value) => defaultFor?.length > 0 && defaultFor.includes(value)
      ) &&
      targetDatePrepopulationSource ===
        targetDatesMilestone.targetDatePrepopulationSource &&
      id !== milestoneId &&
      defaultFor?.length
  );

  for (const milestoneToUpdate of projectMilestonesToUpdate) {
    milestoneToUpdate.targetDatePrepopulationSource = null;
  }

  return projectTemplateUpdate;
};

export function isValidMilestoneLeaderRoles(roles) {
  if (!roles?.length) return true;

  if (roles.some(({ regionId }) => !regionId)) return false;

  let roleKeys = [];

  const filteredRoles = roles.filter(
    ({ productCategories }) => productCategories?.length
  );

  for (const { productCategories, regionId } of filteredRoles) {
    roleKeys = roleKeys.concat(
      productCategories.map((category) => `${regionId}-${category}`)
    );
  }

  const rolesWithoutProductCategoriesKeys = roles
    .filter(
      ({ productCategories }) => !productCategories || !productCategories.length
    )
    .map(({ regionId }) => regionId);

  if (
    rolesWithoutProductCategoriesKeys.length !==
    new Set(rolesWithoutProductCategoriesKeys).size
  ) {
    return false;
  }

  if (
    rolesWithoutProductCategoriesKeys.some((roleWithoutProdCatKey) =>
      roleKeys.find((key) => key.includes(roleWithoutProdCatKey))
    )
  ) {
    return false;
  }

  return roleKeys.length === new Set(roleKeys).size;
}
